module.exports = __webpack_public_path__ + "a21e662a87402c0cb7d13b36d4d12a3b.webp";